import type { CarouselInformativeItemsContentProps } from '../carousel-informative'
import { getCustomStyles } from '../utils'
import Button from './Button'
import Description from './Description'
import Title from './Title'

interface ContentProps {
  classSlide: string
  content: CarouselInformativeItemsContentProps
  contentConfiguration: {
    textAlign: 'left' | 'right' | 'center'
  }
}

const Content = ({
  classSlide,
  content,
  contentConfiguration,
}: ContentProps) => {
  const classSlideContent = `${classSlide}-content`
  const customStylesBadge = getCustomStyles(content?.badge?.styles)
  const customStylesPromoDates = getCustomStyles(content?.promoDates?.styles)
  const { textAlign } = contentConfiguration
  const alignItems =
    textAlign === 'left'
      ? 'flex-start'
      : textAlign === 'right'
      ? 'flex-end'
      : 'center'

  return (
    <div className={classSlideContent} style={{ alignItems }}>
      {content?.badge?.text && (
        <div
          className={`${classSlideContent}-badge`}
          style={{
            ...customStylesBadge,
            marginInline: `${textAlign === 'center' ? 'auto' : '0'}`,
          }}
        >
          {content.badge.text}
        </div>
      )}
      <Title
        classSlide={classSlideContent}
        title={content?.title}
        textAlign={textAlign}
      />
      <Description
        classSlide={classSlideContent}
        description={content?.description}
        textAlign={textAlign}
      />
      <Button classSlide={classSlideContent} button={content?.button} />
      {content?.promoDates?.text && (
        <div
          className={`${classSlideContent}-promoDates`}
          style={{
            ...customStylesPromoDates,
            textAlign,
          }}
        >
          {content.promoDates.text}
        </div>
      )}
    </div>
  )
}

export default Content
